// extracted by mini-css-extract-plugin
export default {"w-full":"ProductSales_w-full__Qx-l7","chart":"ProductSales_chart__OzWQ1"};